var _defs, _path, _path2, _path3, _text, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoBativiz(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 7195.48 5200.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #666c75;\n      }\n\n      .st1, .st2, .st3 {\n        fill: #f9fcfe;\n      }\n\n      .st2 {\n        letter-spacing: .04em;\n      }\n\n      .st2, .st3 {\n        font-family: Gotham-Book, Gotham;\n        font-size: 383.27px;\n      }\n\n      .st3 {\n        letter-spacing: .04em;\n      }\n\n      .st4 {\n        font-size: 465.4px;\n        letter-spacing: .04em;\n      }\n\n      .st4, .st5 {\n        fill: #eb9c40;\n        font-family: Gotham-Light, Gotham;\n        font-weight: 300;\n      }\n\n      .st6 {\n        fill: #e47d3a;\n      }\n\n      .st5 {\n        font-size: 438.02px;\n        letter-spacing: .04em;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1211.61,2324.56s102.57-111.68,47.86-305.42c-54.7-193.74-214.25-186.9-214.25-186.9H107.71c-48.69,0-88.16,39.47-88.16,88.16v805.94c0,58.82,47.68,106.5,106.5,106.5h944.24s218.81-34.19,232.48-280.35c0-166.39-91.17-227.93-91.17-227.93ZM176.82,2019.57c0-20.38,16.52-36.9,36.9-36.9h773.03c65.02,0,117.73,52.71,117.73,117.73v55.2c0,50.51-40.95,91.46-91.46,91.46H213.73c-20.38,0-36.9-16.52-36.9-36.9v-190.59ZM1135.65,2574.98c0,50.51-40.95,91.46-91.46,91.46H213.73c-20.38,0-36.9-16.52-36.9-36.9v-190.59c0-20.38,16.52-36.9,36.9-36.9h804.2c65.02,0,117.73,52.71,117.73,117.73v55.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3320.09,2832.83h50.05c29.19,0,52.85-23.66,52.85-52.85v-779.08h387.92c46.25,0,83.75-37.49,83.75-83.75h0c0-46.92-38.03-84.95-84.95-84.95h-965.36c-45.56,0-82.49,36.93-82.49,82.49h0c0,48.87,39.62,88.49,88.49,88.49h397.14s12.7,770.73,12.7,770.73c.54,32.69,27.2,58.92,59.9,58.92Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5677.04,2179.92v593.67c0,32.72,33.09,59.25,73.92,59.25h22.03c42.68,0,77.28-27.73,77.28-61.94v-595.16c0-33.61-34-60.87-75.94-60.87h-16.12c-44.83,0-81.16,29.13-81.16,65.05Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(854.18 3559.66)"
  }, /*#__PURE__*/React.createElement("tspan", null, /*#__PURE__*/React.createElement("tspan", {
    className: "st2",
    x: 0,
    y: 0
  }, "Pilotez"), /*#__PURE__*/React.createElement("tspan", {
    className: "st4",
    x: 1399.3,
    y: 0
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "st5",
    x: 1523.56,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "st2",
    x: 1671.17,
    y: 0
  }, "Analysez"), /*#__PURE__*/React.createElement("tspan", {
    className: "st4",
    x: 3503.56,
    y: 0
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "st5",
    x: 3627.82,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "st3",
    x: 3775.43,
    y: 0
  }, "D\xE9cidez"), /*#__PURE__*/React.createElement("tspan", {
    className: "st4",
    x: 5415.43,
    y: 0
  }, ".")))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4057.28,1922.87v827.39c0,45.6,33.09,82.57,73.92,82.57h22.03c42.68,0,77.28-38.65,77.28-86.33v-829.47c0-46.85-34-84.83-75.94-84.83h-16.12c-44.83,0-81.16,40.59-81.16,90.67Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4468.13,1995.32l501.01,759.77c53.51,81.15,172.78,80.47,225.37-1.27l577.9-898.25h-138.77c-73.79,0-142.41,37.93-181.66,100.41l-365.43,581.7-446.18-649.61c-27.58-40.15-82.35-50.62-122.79-23.47l-26.79,17.99c-37.22,24.99-47.33,75.31-22.65,112.73Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M5579.23,1730.85l120.58-178.09c21.66-31.98,57.76-51.14,96.39-51.14h188.01c5.83,0,9.34,6.45,6.18,11.35l-111.41,172.5c-22.89,35.45-62.21,56.86-104.41,56.86h-189.25c-5.9,0-9.4-6.6-6.09-11.48Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6058.57,1907.66v-7.81c0-42.95,34.82-77.78,77.78-77.78h952.8c47.93,0,86.79,38.86,86.79,86.79h0c0,46.42-20.74,90.42-56.54,119.97l-763.97,630.43h743.9c42.31,0,76.61,34.3,76.61,76.61h0c0,47.95-38.87,86.83-86.82,86.83h-976.34c-37.3,0-67.54-30.24-67.54-67.54h0c0-35.45,15.55-69.12,42.53-92.11l791.32-674.21-746-6.07c-41.25-.34-74.51-33.87-74.51-75.12Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2792.75,2693.82l-565.06-822.21c-45.47-66.16-143.19-66.02-188.47.26l-581.34,851c-34.82,50.97,1.68,120.1,63.4,120.1h20.28c30.47,0,58.97-15.1,76.08-40.32l146.03-215.2,739.18,9.13,151.5,215.29c13.72,19.5,36.08,31.1,59.92,31.1,76.66,0,121.9-85.97,78.48-149.16ZM1891.43,2403.37l244.11-340.64,239.55,340.64h-483.66Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBativiz);
export default __webpack_public_path__ + "static/media/logo-bativiz.67fbe68be80426f35ef313541c556c10.svg";
export { ForwardRef as ReactComponent };